<script setup lang="ts">
import type { SaferGamblingQas } from '@content-utils/schemas'

export interface SaferGamblingArchiveProps {
    category: string
    title: string
    icon: string
}

const props = defineProps<SaferGamblingArchiveProps>()

const { queryByCategory } = useLayeredContent()

const { data: qas } = useAsyncData(
    `saferGambling:qas:${props.category}`,
    () => queryByCategory<SaferGamblingQas>('safer-gambling/qas', props.category),
    { server: false }
)

const mappedQas = computed(() => {
    if (!qas.value?.length) return []

    return qas.value.map(qa => ({
        id: (qa as any).id as string,
        title: qa.title,
        video_id: qa.video_id,
        body: (qa as any).body,
        ctas: qa.ctas ?? [],
        expandableTextBlocks: qa.expandableTextBlocks ?? [],
        stem: (qa as any).stem as string | undefined
    }))
})
</script>

<template>
    <SaferGamblingArchivePanel
        :icon="props.icon"
        :title="props.title"
        :qas="mappedQas"
    />
</template>
